import { i18n } from '../services/i18n/i18n';
export const useT = () => {
    return {
        t: i18n.t
    };
};
//# sourceMappingURL=useT.js.map